import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';

const MemberList = (props) => {
  const { column, data, selectedPartnerGym } = props;

  const { t } = useLanguage();
  const history = useHistory();

  // 생년월일 포맷 //
  function formatBirthDay(bd) {
    const y = bd.slice(0, 4), m = bd.slice(4, 6), d = bd.slice(6, 8);
    const order = t('statistics.calendar.dateOrder');
    const sep = t('statistics.calendar.dateSeparator');
    if (order === 'MDY') return m + sep + d + sep + y;
    return y + sep + m + sep + d;
  }

  // ISO 날짜 포맷 //
  function formatIsoDate(iso) {
    const parts = iso.split('T')[0].split('-');
    const order = t('statistics.calendar.dateOrder');
    const sep = t('statistics.calendar.dateSeparator');
    if (order === 'MDY') return parts[1] + sep + parts[2] + sep + parts[0];
    return parts[0] + sep + parts[1] + sep + parts[2];
  }

  // 전화번호 표시 //
  function calcPhone(viewData) {
    if (viewData.phone === '') return t('statistics.noPhone');
    else return viewData.phone.slice(0,3) + '-' + viewData.phone.slice(3,7) + '-' + viewData.phone.slice(7, 11);
  }

  // 회원 정보 클릭시 //
  function onClickMemberInfo(data) {
    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) history.push('/member/valid/detail/' + data.memberId);
    else history.push('/member/partner_gym/detail/' + data.memberId);
    // () => history.push('/member/valid/detail/' + data.memberId)
  }

  return (
    <TopLevelWrapper>
      <Table>
        <Head>
          <HeadTr>
            <Td style={{ width: `67px`, marginLeft: '8px' }}>{t('statistics.table.colName')}</Td>
            <Td style={{ width: `55px` }}>{t('statistics.table.colGender')}</Td>
            <Td style={{ width: `98px` }}>{t('statistics.table.colBirth')}</Td>
            <Td style={{ width: `114px` }}>{t('statistics.table.colPhone')}</Td>
            {/* <Td style={{ width: `113px` }}>{column}</Td> */}
            <Td style={{ width: `103px` }}>{column}</Td>
          </HeadTr>
        </Head>
      </Table>
      <Table>
        <Body>
          {
            data.map((data, index) => (
              <BodyTr key={index} onClick={() => onClickMemberInfo(data)}>
                <Td style={{ width: `60px`, marginLeft: '8px', overflow: 'hidden' , whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {data.name}
                </Td>
                <Td style={{ width: `56px`, marginLeft: '7px' }}>
                  {data.gender === 'male' ? t('statistics.maleShort') : t('statistics.femaleShort')}
                </Td>
                <Td style={{ width: `98px` }}>
                  {formatBirthDay(data.birthDay)}
                </Td>
                {/* <Td style={{ width: `114px` }}>
                  {data.phone[0]
                    + data.phone[1]
                    + data.phone[2]
                    + '-'
                    + data.phone[3]
                    + data.phone[4]
                    + data.phone[5]
                    + data.phone[6]
                    + '-' +
                    + data.phone[7]
                    + data.phone[8]
                    + data.phone[9]
                    + data.phone[10]}
                </Td> */}
                <Td style={{ width: `114px` }}>
                  {calcPhone(data)}
                </Td>
                <Td style={{ width: `80px` }}>
                  { column === t('statistics.memberMovement.registrationDate') ? formatIsoDate(data.startDate) : formatIsoDate(data.endDate) }
                </Td>
              </BodyTr>
            ))
          }
        </Body>
      </Table>
    </TopLevelWrapper>
  )
}

export default MemberList;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Table = styled.table`
  display: flex;
  flex-direction: column;
`;

const Head = styled.thead`

`;

const Body = styled.tbody`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // width: 464px;
  width: 454px;
  height: 200px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		// height: 92px;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
    // height: 439px;
		// border: 4px solid transparent;
		background-color: #F0F0F0;
		border-radius: 200px;
	}
`;

const HeadTr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 32px;

  margin-top: 16px;
  border-radius: 8px;
  background-color: #ECECEC;
`;

const BodyTr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #F4F2F0;
  }
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  height: 36px;

  color: #595959;
`;